module.exports = __webpack_public_path__ + "media/images/balance-product-greenstart-a165646b7b5413eb2a00fe66567eca7a.png";